<ng-container>
  <div class="row">
    <div class="col text-right pb-3 mr-3">
      <a class="go-back text-right btn btn-link" (click)="location.back()">
        <i class="fa fa-caret-left pr-1"></i>
        Go back
      </a>
    </div>
  </div>
</ng-container>

<mat-accordion>
  <mat-expansion-panel *ngFor="let item of purchaseOrder.line_items"
                       (opened)="getSteps(item)">
    <mat-expansion-panel-header [collapsedHeight]="'48px'">
      <mat-panel-title>
        <strong class="pr-1">{{ item.product_name }}</strong>
        <small>Reported: {{ item.quantity_complete }} - Ordered: {{ item.quantity_ordered }}</small>
      </mat-panel-title>
      <mat-panel-description></mat-panel-description>
    </mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <ul class="list-group list-group-flush" *ngIf="item?.steps?.length else NoSteps">
        <li
          *ngFor="let step of item?.steps; let i = index"
          class="step list-group-item p-2">

          <div class="w-100">
            <span class="name">
              <strong>{{ step.name }}</strong>
            </span>
            <mat-form-field [style.width.px]=150 class="pull-right">
              <input matInput (change)="setStepProgress($event, item.id, step)" placeholder="Quantity" [value]="step.quantity">
            </mat-form-field>
          </div>
          <small class="description text-muted" *ngIf="step.description">
            <strong>Description:</strong> {{ step.description }}
          </small>
          <small class="text-muted" *ngIf="step.barcode">
            <strong>Barcode:</strong> {{ step.barcode }}
          </small>
          <small class="text-muted">
            <strong>Last Updated:</strong> {{ step.updated_at | amTimeAgo }}
          </small>
        </li>
      </ul>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>

<ng-template #NoSteps>
  <p>This product doesn't have steps</p>
</ng-template>
